export default {"src":"/_next/static/media/RotavatorIcon.9ebefdf0.svg","height":62,"width":96};